import Phaser from 'phaser';

export class PreloadScene extends Phaser.Scene {
  private progressBar!: Phaser.GameObjects.Graphics;
  private progressBox!: Phaser.GameObjects.Graphics;
  private loadingText!: Phaser.GameObjects.Text;
  private percentText!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload(): void {
    this.createLoadingUI();
    this.setupLoadingEvents();

    // Since we use procedural generation, there are no assets to load
    // This scene demonstrates the loading pattern for future use
    // Simulate a brief load to show the loading screen
    this.load.on('complete', () => {
      this.time.delayedCall(500, () => {
        this.scene.start('MenuScene');
      });
    });
  }

  private createLoadingUI(): void {
    const centerX = this.cameras.main.width / 2;
    const centerY = this.cameras.main.height / 2;

    // Progress box background
    this.progressBox = this.add.graphics();
    this.progressBox.fillStyle(0x1A365D, 0.8);
    this.progressBox.fillRoundedRect(centerX - 160, centerY - 25, 320, 50, 10);

    // Progress bar (filled portion)
    this.progressBar = this.add.graphics();

    // Loading text
    this.loadingText = this.add.text(centerX, centerY - 50, 'Initializing Microscope...', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '20px',
      color: '#E2E8F0',
    });
    this.loadingText.setOrigin(0.5);

    // Percentage text
    this.percentText = this.add.text(centerX, centerY, '0%', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '18px',
      color: '#4299E1',
    });
    this.percentText.setOrigin(0.5);
  }

  private setupLoadingEvents(): void {
    this.load.on('progress', (value: number) => {
      this.updateProgress(value);
    });

    this.load.on('complete', () => {
      this.progressBar.destroy();
      this.progressBox.destroy();
      this.loadingText.destroy();
      this.percentText.destroy();
    });

    // Since we have no assets, manually trigger progress
    this.updateProgress(1);
  }

  private updateProgress(value: number): void {
    const centerX = this.cameras.main.width / 2;
    const centerY = this.cameras.main.height / 2;

    this.progressBar.clear();
    this.progressBar.fillStyle(0x4299E1, 1);
    this.progressBar.fillRoundedRect(
      centerX - 155,
      centerY - 20,
      310 * value,
      40,
      8
    );

    this.percentText.setText(`${Math.round(value * 100)}%`);
  }
}
